







import { Vue, Component, Prop } from 'vue-property-decorator';
@Component({
  components: {}
})
export default class AMSBreadcrumb extends Vue {
  @Prop({ required: true }) BreadItem!: object;
}
